<!-- 过户记录 -->
<template>
  <div>
    <div class="table-fixed">
      <a-table ref="table" size="middle" :scroll="{x: 'max-content'}" bordered rowKey="id" :columns="columns"
        :dataSource="dataSource" :pagination="ipagination" :loading="loading" class="j-table-force-nowrap"
        :components="drag(columns)" @change="handleTableChange">
        <span slot="newWtPriceSlot" slot-scope="text, record">
          <span v-if="record.wtName"> {{record.wtName}}({{record.wtTotalPrice?record.wtTotalPrice + $t('元'): '--'}})</span>
          <span v-else>--</span>
        </span>
        <span slot="oldWtPriceSlot" slot-scope="text, record">
          <span v-if="record.oldWtName"> {{record.oldWtName}}({{record.oldWtTotalPrice?record.oldWtTotalPrice + $t('元'): '--'}})</span>
          <span v-else>--</span>
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">{{ $t('详情') }}</a>
        </span>
      </a-table>
    </div>
    <meter-userinfo-transfer-record-modal ref="modalForm" @ok="modalFormOk"></meter-userinfo-transfer-record-modal>
  </div>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import {
    mixinDevice
  } from '@/utils/mixin'
  import {
    JeecgListMixin
  } from '@/mixins/JeecgListMixin'
  import {
    AreaChoosetMixin
  } from '@/mixins/AreaChooseMixin'
  import configService from '@/utils/service/config.service'
  import {
    getAction,
    httpAction
  } from '@/api/manage'
  import moment from 'moment'
  import {
    filterDictTextByCache
  } from '@/components/dict/JDictSelectUtil'
  import Vue from 'vue'
  import TableDragResize from '@/mixins/TableDragResize'
  import MeterUserinfoTransferRecordModal from '@/views/meterUserRecordList/modules/MeterUserinfoTransferRecordModal.vue'
  export default {
    name: 'TransferRecord',
    mixins: [JeecgListMixin, mixinDevice, AreaChoosetMixin, TableDragResize],
    components: {
      MeterUserinfoTransferRecordModal
    },
    props: {
      id: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        description: 'TransferRecord管理页面',
        collapsed: false,
        url: {
          list: "/jeecg-charge/meter/meterUserinfoTransferRecord/list",
        },
      }
    },
    watch: {
      id(val) {
        if (val) {
          this.loadData();
        }
      }
    },
    created() {},
    // i18n：表头使用 computed 以响应语言切换
    computed: {
      columns() {
        return [{
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: "center",
            customRender: (t, r, index) => {
              return parseInt(index) + 1;
            },
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon'
            }
          }, {
            title: this.$t('表编号'),
            align: "center",
            dataIndex: 'meterId',
            width: 150,
            ellipsis: true
          }, {
            title: this.$t('用户编号'),
            align: "center",
            dataIndex: 'userId',
            width: 150,
            ellipsis: true
          }, {
            title: this.$t('新用户姓名'),
            align: "center",
            dataIndex: 'userName',
            width: 150,
            ellipsis: true
          }, {
            title: this.$t('原用户姓名'),
            align: "center",
            dataIndex: 'oldUserName',
            width: 150,
            ellipsis: true
          }, {
            title: this.$t('新用户手机号'),
            align: "center",
            dataIndex: 'userPhone',
            width: 150,
            ellipsis: true
          }, {
            title: this.$t('原用户手机号'),
            align: "center",
            dataIndex: 'oldUserPhone',
            width: 150,
            ellipsis: true
          }, {
            title: this.$t('新身份证号'),
            align: "center",
            dataIndex: 'userIdNumber',
            width: 150,
            ellipsis: true
          }, {
            title: this.$t('原身份证号'),
            align: "center",
            dataIndex: 'oldUserIdNumber',
            width: 150,
            ellipsis: true
          }, {
            title: this.$t('新价格信息'),
            align: "center",
            dataIndex: 'newWtPrice',
            scopedSlots: {
              customRender: 'newWtPriceSlot'
            },
            width: 150,
            ellipsis: true
          }, {
            title: this.$t('原价格信息'),
            align: "center",
            dataIndex: 'oldWtPrice',
            scopedSlots: {
              customRender: 'oldWtPriceSlot'
            },
            width: 150,
            ellipsis: true
          },
          {
            title: this.$t('创建时间'),
            align: "center",
            dataIndex: 'createTime',
            width: 150,
            ellipsis: true
          }, {
            title: this.$t('创建人'),
            align: "center",
            dataIndex: 'createBy',
            width: 150,
            ellipsis: true
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align: "center",
            fixed: "right",
            width: 100,
            scopedSlots: {
              customRender: 'action'
            }
          }
        ]
      }
    },
    methods: {
      loadData() {
        var params = this.getQueryParams(); //查询条件
        params.userId = this.id;
        getAction(this.url.list, params).then(res => {
          if (res.success) {
            this.dataSource = res.result.records;
            this.ipagination.total = res.result.total;
          }
        })
      },
    }
  }
</script>
<style scoped>
  .my-area-select-tree /deep/ li .ant-tree-node-content-wrapper {
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;
  }
</style>